import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--bg)" }}>
        <div className="text-center">
          <div className="inline-block w-10 h-10 border-2 border-t-transparent rounded-full animate-spin"
               style={{ borderColor: "var(--rose-gold)", borderTopColor: "transparent" }} />
          <p className="mt-4 text-sm" style={{ color: "var(--text-secondary)" }}>Carregando…</p>
        </div>
      </div>
    );
  }

  if (!user) {
    const target = adminOnly ? "/admin/login" : "/login";
    return <Navigate to={target} state={{ from: location }} replace />;
  }

  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/membros" replace />;
  }

  return children;
}
